@if ((breadcrumbs$ | async); as breadcrumbs) {
  <nav aria-label="breadcrumb">
    @if (breadcrumbs.length > 0) {
      <ol class="breadcrumb bg-transparent px-3 py-2">
        <li class="breadcrumb-item">
          <a routerLink="/">Inicio</a> </li>
          @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
            <li class="breadcrumb-item" [ngClass]="{ 'active': last }">
              @if (!last) {
                <a [routerLink]="breadcrumb.url" [queryParams]="breadcrumb.queryParams">{{ breadcrumb.label }}</a>
              }
              @if (last) {
                <span>{{ breadcrumb.label }}</span>
              }
            </li>
          }
        </ol>
      }
    </nav>
  }